/**
 * Card / panel primitive (design system, FOUNDATION — v2).
 * Rounded-2xl, layered depth (--shadow-1), optional game-layer glows.
 * `interactive` adds a hover lift (CSS — cheap, works with reduced motion).
 */
import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Cosmetic glow motifs: killstreak gold / berserker fire / brand accent /
   *  super-reject violet / like-shield cyan. */
  glow?: "none" | "gold" | "berserk" | "accent" | "sr" | "like";
  padding?: "md" | "lg";
  /** Hover lift + brighter border — for tappable cards. */
  interactive?: boolean;
  children?: ReactNode;
}

export function Card({
  glow = "none",
  padding = "md",
  interactive = false,
  className,
  children,
  ...rest
}: CardProps) {
  const classes = [
    "card",
    padding === "lg" ? "card--pad-lg" : "",
    glow !== "none" ? `card--glow-${glow}` : "",
    interactive ? "card--interactive" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
